'use client'

import { isEqual } from 'lodash-es'
import { useCallback } from 'react'
import { FieldValues, Path, PathValue, useFormContext } from 'react-hook-form'

export const useEnhancedFormContext = <T extends FieldValues>() => {
  const { getValues, setValue, ...form } = useFormContext<T>()

  const setValuesIfChanged = useCallback(
    (values: Record<string, unknown>) => {
      Object.entries(values).forEach(([name, value]) => {
        const currentValue = getValues(name as Path<T>)

        if (!isEqual(currentValue, value)) {
          setValue(name as Path<T>, value as PathValue<T, Path<T>>)
        }
      })
    },
    [getValues, setValue],
  )

  return {
    ...form,
    setValue,
    setValuesIfChanged,
    getValues,
  }
}
